import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-kamona-custom-error-display',
	templateUrl: './kamona-custom-error-display.component.html',
	styleUrls: ['./kamona-custom-error-display.component.scss']
})
export class KamonaCustomErrorDisplayComponent implements OnInit {
    @Input() designType: any;
	@Input() errorMessage: string;
	@Input() errorDescription: string;

	constructor() { }

	ngOnInit(): void {
		if (!this.designType){
			this.designType = 'OLD_DESIGN';
		}
	}

}

export type ErrorDesignType = 'OLD_DESIGN' | 'KAMONA_DESIGN';
